/**
 * @generated SignedSource<<734f47f74e29e50d2b73c0544a9f847c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ProjectTentativeMutation$variables = {
  id: number;
};
export type ProjectTentativeMutation$data = {
  readonly tentativeProject: {
    readonly project: {
      readonly active: boolean;
      readonly confirmed: boolean;
      readonly id: number;
    } | null | undefined;
  };
};
export type ProjectTentativeMutation = {
  response: ProjectTentativeMutation$data;
  variables: ProjectTentativeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProjectResult",
    "kind": "LinkedField",
    "name": "tentativeProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "projects",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "confirmed",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectTentativeMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectTentativeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f930e86efd505e57b7a2e2318350dd49",
    "id": null,
    "metadata": {},
    "name": "ProjectTentativeMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectTentativeMutation(\n  $id: Int!\n) {\n  tentativeProject(id: $id) {\n    project {\n      id\n      active\n      confirmed\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0b5efe043c2eaa78702463520b194904";

export default node;
